import prize from '../i/public/icon/icon_bonus.png';
import prizehy from '../i/public/icon/icon_bonus-hy.png';
import moment from 'moment';

// 注单详情的状态***根据状态码返回状态的描述文字和样式选择器
export function transStatusToText(item) {
  var o = {};
  o.className = 'sp-green';
  if (item.iscancel == '1') {
    o.text = '本人撤单';
  }
  if (item.iscancel == '2') {
    o.text = '平台撤单';
  }
  if (item.iscancel == '3') {
    o.text = '错开撤单';
  }
  if (item.iscancel == '0') {
    if (item.isgetprize == '0') {
      o.text = '未开奖';
      o.className = 'font-green';
    }
    if (item.isgetprize == '2') {
      o.text = '未中奖';
      o.className = 'font-gray';
    }
    if (item.isgetprize == '1') {
      if (item.prizestatus == '0') {
        o.text = '未派奖';
        o.className = 'font-green';
      } else {
        o.text = '已派奖';
        o.className = 'sp-orange';
      }
    }
  }
  return o;
}


/**
 * 从URL上取参数
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
export function getUrlParam(name) {
  var url = window.location.href.toLowerCase();
  var results = (new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")).exec(url);
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results || !results[2]) {
    return null
  } else {
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}

var hexcase = 0;
export function Hex_MD5(a) { if (a == "") return a; return rstr2hex(rstr_md5(str2rstr_utf8(a))) } function hex_hmac_md5(a, b) { return rstr2hex(rstr_hmac_md5(str2rstr_utf8(a), str2rstr_utf8(b))) } function md5_vm_test() { return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72" } function rstr_md5(a) { return binl2rstr(binl_md5(rstr2binl(a), a.length * 8)) } function rstr_hmac_md5(c, f) { var e = rstr2binl(c); if (e.length > 16) { e = binl_md5(e, c.length * 8) } var a = Array(16), d = Array(16); for (var b = 0; b < 16; b++) { a[b] = e[b] ^ 909522486; d[b] = e[b] ^ 1549556828 } var g = binl_md5(a.concat(rstr2binl(f)), 512 + f.length * 8); return binl2rstr(binl_md5(d.concat(g), 512 + 128)) } function rstr2hex(c) { try { hexcase } catch (g) { hexcase = 0 } var f = hexcase ? "0123456789ABCDEF" : "0123456789abcdef"; var b = ""; var a; for (var d = 0; d < c.length; d++) { a = c.charCodeAt(d); b += f.charAt((a >>> 4) & 15) + f.charAt(a & 15) } return b } function str2rstr_utf8(c) { var b = ""; var d = -1; var a, e; while (++d < c.length) { a = c.charCodeAt(d); e = d + 1 < c.length ? c.charCodeAt(d + 1) : 0; if (55296 <= a && a <= 56319 && 56320 <= e && e <= 57343) { a = 65536 + ((a & 1023) << 10) + (e & 1023); d++ } if (a <= 127) { b += String.fromCharCode(a) } else { if (a <= 2047) { b += String.fromCharCode(192 | ((a >>> 6) & 31), 128 | (a & 63)) } else { if (a <= 65535) { b += String.fromCharCode(224 | ((a >>> 12) & 15), 128 | ((a >>> 6) & 63), 128 | (a & 63)) } else { if (a <= 2097151) { b += String.fromCharCode(240 | ((a >>> 18) & 7), 128 | ((a >>> 12) & 63), 128 | ((a >>> 6) & 63), 128 | (a & 63)) } } } } } return b } function rstr2binl(b) { var a = Array(b.length >> 2); for (var c = 0; c < a.length; c++) { a[c] = 0 } for (var c = 0; c < b.length * 8; c += 8) { a[c >> 5] |= (b.charCodeAt(c / 8) & 255) << (c % 32) } return a } function binl2rstr(b) { var a = ""; for (var c = 0; c < b.length * 32; c += 8) { a += String.fromCharCode((b[c >> 5] >>> (c % 32)) & 255) } return a } function binl_md5(p, k) { p[k >> 5] |= 128 << ((k) % 32); p[(((k + 64) >>> 9) << 4) + 14] = k; var o = 1732584193; var n = -271733879; var m = -1732584194; var l = 271733878; for (var g = 0; g < p.length; g += 16) { var j = o; var h = n; var f = m; var e = l; o = md5_ff(o, n, m, l, p[g + 0], 7, -680876936); l = md5_ff(l, o, n, m, p[g + 1], 12, -389564586); m = md5_ff(m, l, o, n, p[g + 2], 17, 606105819); n = md5_ff(n, m, l, o, p[g + 3], 22, -1044525330); o = md5_ff(o, n, m, l, p[g + 4], 7, -176418897); l = md5_ff(l, o, n, m, p[g + 5], 12, 1200080426); m = md5_ff(m, l, o, n, p[g + 6], 17, -1473231341); n = md5_ff(n, m, l, o, p[g + 7], 22, -45705983); o = md5_ff(o, n, m, l, p[g + 8], 7, 1770035416); l = md5_ff(l, o, n, m, p[g + 9], 12, -1958414417); m = md5_ff(m, l, o, n, p[g + 10], 17, -42063); n = md5_ff(n, m, l, o, p[g + 11], 22, -1990404162); o = md5_ff(o, n, m, l, p[g + 12], 7, 1804603682); l = md5_ff(l, o, n, m, p[g + 13], 12, -40341101); m = md5_ff(m, l, o, n, p[g + 14], 17, -1502002290); n = md5_ff(n, m, l, o, p[g + 15], 22, 1236535329); o = md5_gg(o, n, m, l, p[g + 1], 5, -165796510); l = md5_gg(l, o, n, m, p[g + 6], 9, -1069501632); m = md5_gg(m, l, o, n, p[g + 11], 14, 643717713); n = md5_gg(n, m, l, o, p[g + 0], 20, -373897302); o = md5_gg(o, n, m, l, p[g + 5], 5, -701558691); l = md5_gg(l, o, n, m, p[g + 10], 9, 38016083); m = md5_gg(m, l, o, n, p[g + 15], 14, -660478335); n = md5_gg(n, m, l, o, p[g + 4], 20, -405537848); o = md5_gg(o, n, m, l, p[g + 9], 5, 568446438); l = md5_gg(l, o, n, m, p[g + 14], 9, -1019803690); m = md5_gg(m, l, o, n, p[g + 3], 14, -187363961); n = md5_gg(n, m, l, o, p[g + 8], 20, 1163531501); o = md5_gg(o, n, m, l, p[g + 13], 5, -1444681467); l = md5_gg(l, o, n, m, p[g + 2], 9, -51403784); m = md5_gg(m, l, o, n, p[g + 7], 14, 1735328473); n = md5_gg(n, m, l, o, p[g + 12], 20, -1926607734); o = md5_hh(o, n, m, l, p[g + 5], 4, -378558); l = md5_hh(l, o, n, m, p[g + 8], 11, -2022574463); m = md5_hh(m, l, o, n, p[g + 11], 16, 1839030562); n = md5_hh(n, m, l, o, p[g + 14], 23, -35309556); o = md5_hh(o, n, m, l, p[g + 1], 4, -1530992060); l = md5_hh(l, o, n, m, p[g + 4], 11, 1272893353); m = md5_hh(m, l, o, n, p[g + 7], 16, -155497632); n = md5_hh(n, m, l, o, p[g + 10], 23, -1094730640); o = md5_hh(o, n, m, l, p[g + 13], 4, 681279174); l = md5_hh(l, o, n, m, p[g + 0], 11, -358537222); m = md5_hh(m, l, o, n, p[g + 3], 16, -722521979); n = md5_hh(n, m, l, o, p[g + 6], 23, 76029189); o = md5_hh(o, n, m, l, p[g + 9], 4, -640364487); l = md5_hh(l, o, n, m, p[g + 12], 11, -421815835); m = md5_hh(m, l, o, n, p[g + 15], 16, 530742520); n = md5_hh(n, m, l, o, p[g + 2], 23, -995338651); o = md5_ii(o, n, m, l, p[g + 0], 6, -198630844); l = md5_ii(l, o, n, m, p[g + 7], 10, 1126891415); m = md5_ii(m, l, o, n, p[g + 14], 15, -1416354905); n = md5_ii(n, m, l, o, p[g + 5], 21, -57434055); o = md5_ii(o, n, m, l, p[g + 12], 6, 1700485571); l = md5_ii(l, o, n, m, p[g + 3], 10, -1894986606); m = md5_ii(m, l, o, n, p[g + 10], 15, -1051523); n = md5_ii(n, m, l, o, p[g + 1], 21, -2054922799); o = md5_ii(o, n, m, l, p[g + 8], 6, 1873313359); l = md5_ii(l, o, n, m, p[g + 15], 10, -30611744); m = md5_ii(m, l, o, n, p[g + 6], 15, -1560198380); n = md5_ii(n, m, l, o, p[g + 13], 21, 1309151649); o = md5_ii(o, n, m, l, p[g + 4], 6, -145523070); l = md5_ii(l, o, n, m, p[g + 11], 10, -1120210379); m = md5_ii(m, l, o, n, p[g + 2], 15, 718787259); n = md5_ii(n, m, l, o, p[g + 9], 21, -343485551); o = safe_add(o, j); n = safe_add(n, h); m = safe_add(m, f); l = safe_add(l, e) } return Array(o, n, m, l) } function md5_cmn(h, e, d, c, g, f) { return safe_add(bit_rol(safe_add(safe_add(e, h), safe_add(c, f)), g), d) } function md5_ff(g, f, k, j, e, i, h) { return md5_cmn((f & k) | ((~f) & j), g, f, e, i, h) } function md5_gg(g, f, k, j, e, i, h) { return md5_cmn((f & j) | (k & (~j)), g, f, e, i, h) } function md5_hh(g, f, k, j, e, i, h) { return md5_cmn(f ^ k ^ j, g, f, e, i, h) } function md5_ii(g, f, k, j, e, i, h) { return md5_cmn(k ^ (f | (~j)), g, f, e, i, h) } function safe_add(a, d) { var c = (a & 65535) + (d & 65535); var b = (a >> 16) + (d >> 16) + (c >> 16); return (b << 16) | (c & 65535) } function bit_rol(a, b) { return (a << b) | (a >>> (32 - b)) };

export function formatMoney(number, places, symbol, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbol = symbol !== undefined ? symbol : "$";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}


export function setCookie(name, value, exSecend = 0) {
  var c_date,
    c_name = name + "=" + value + ";",
    c_expi = "",
    c_path = "path=/";

  if (exSecend > 0) {
    c_date = new Date();
    c_date.setTime(c_date.getTime() + (exSecend * 1000));
    c_expi = "expires=" + c_date.toGMTString() + ";";
  }
  // create the cookie
  document.cookie = c_name + c_expi + c_path;
}


export function getCookie(name) {
  var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
  return !!pair ? pair[1] : null;
}

export function delCookie(name) {
  var exp = new Date();
  exp.setTime(-1000);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "='';expires=" + exp.toGMTString() + ';path=/';
}

// 计算时间差
// time1 开始时间 time2 结束时间
// type=1 秒 type=2 分 type=3 小时
export function diffTime(time1, time2, type) {//2017-08-03 17:21:19    2017-08-03 17:21:02
  time1 = time1.replace(/\-/g, '/');
  time2 = time2.replace(/\-/g, '/');

  var sTime = new Date(time1);//开始时间
  var eTime = new Date(time2);//结束时间

  // type返回类型
  var timeType = 1;
  switch (type) {
    case 1:
      timeType = 1000;//second
      break;
    case 2:
      timeType = 1000 * 60;//minute
      break;
    case 3:
      timeType = 1000 * 3600;//hour
      break;
    default:
      break;
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
}

// 计算时间差,返回毫秒数
export function dateDiff(date1, date2) {
  if (!date1 || !date2) {
    return 0;//时间差计算错误，参数异常
  }
  // ios的bug
  date1 = date1.replace(/-/g, '/');
  date2 = date2.replace(/-/g, '/');

  var t1 = new Date(date1).getTime();
  var t2 = new Date(date2).getTime();
  var sec = Math.abs(t2 - t1);
  return sec;
}

// 时间差秒数转化为时分秒的数组
// 返回的数值全部为字符串格式
export function secondConvertHMS(second) {
  return [this.fillZero(parseInt(second / 3600), 2), this.fillZero(parseInt((second % 3600) / 60), 2), this.fillZero(parseInt((second % 3600) % 60), 2)];
}

// 补零函数
// num=补到多少位
export function fillZero(str, num) {
  var zero = '0000000000000000000000';
  var l = str.toString().length;
  if (l < num) {
    return zero.substr(0, num - l) + str.toString();
  }
  return str.toString();
}

/**
 * 读取本地文档文件
 * @param  {[type]}   file     [HTML5 file对象]
 * @param  {Function} callback [回调函数，用于接受读取完成后的数据]
 */
export function loadTextFile(file, callback) {
  var reader = new FileReader();
  reader.onload = function () {
    callback(this.result)
  }
  reader.readAsText(file);
}

// 转换将进组显示
export function formatPrizeDisplay(value) {
  return value.split('-')[0].substring(2);
}

// 秒数转换成HH:MM:SS格式
export function formatTime(seconed, type) {
  if (seconed < 0) {
    return '--:--:--';
  }
  var _seconed = seconed % 60;
  var _minute = Math.floor(seconed / 60);
  var _hour = Math.floor(_minute / 60);
  _minute = _minute % 60;
  if (_seconed < 10) {
    _seconed = '0' + _seconed;
  }
  if (_minute < 10) {
    _minute = '0' + _minute;
  }
  if (_hour < 10) {
    _hour = '0' + _hour;
  }
  return _hour + ':' + _minute + ':' + _seconed;
}

// 逆转
export function formatFromTime(time) {
  var arr = time.split(':');
  if (arr.length < 3) return 0;
  var _seconed = arr[2];
  var _minute = arr[1];
  var _hour = arr[0];
  var total = parseInt(_hour) * 60 * 60 + parseInt(_minute) * 60 + parseInt(_seconed);
  return total;
}

/**
 * 获取推送原对象
 * @param  {[type]} url    [description]
 * @param  {[type]} status [description]
 * @param  {[type]} token  [description]
 * @return {[type]}        [description]
 */
import PushStream from './pushstream'
export function getPushStream(url, status, token) {
  var host, port;
  if (status == "0") {
    return "";
  }
  if (url != undefined && status == "1") {
    // 解析推送服务URL
    if (url.split(":").length != 1) {
      host = url.split(":")[0];
    } else {
      host = url;
    }
    // 实例化 PushStream
    return new PushStream({
      host: host,
      port: window.location.protocol == 'https:' ? '443' : '80',
      modes: "longpolling",
      messagesControlByArgument: false,
      tagArgument: 'tag',
      timeArgument: 'time',
      useSSL: window.location.protocol == 'https:' ? true : false,
      extraParams: function () {
        return { 'token': token };
      },
      useJSONP: true,
      timeout: 30000
    });
  }
  return "";
}


/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).pattern("YYYY-MM-DD hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).pattern("YYYY-MM-DD E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).pattern("YYYY-MM-DD EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).pattern("YYYY-MM-DD EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
export function importDatePrototype() {
  Date.prototype.pattern = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
      "H+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    var week = {
      "0": "\u65e5",
      "1": "\u4e00",
      "2": "\u4e8c",
      "3": "\u4e09",
      "4": "\u56db",
      "5": "\u4e94",
      "6": "\u516d"
    };
    if (fmt == 'EE') {
      return "周" + week[this.getDay()];
    }
    return momentDate(this).format(fmt)
  }
}

/**
 * 生成一个从 from 到 to 数组
 * @param  {[type]} from [description]
 * @param  {[type]} to   [description]
 * @return {[type]}      [description]
 */
export function makeBetweenNo(from, to) {
  let result = [];
  for (let i = from; i <= to; i++) {
    result.push(i)
  }
  return result;
}


/**
 * 回到顶部
 */
export function scroll2Top() {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
}

/**
 * 滚到底部
 */
export function scroll2Bottom() {
	document.body.scrollTop = document.documentElement.scrollTop = document.body.scrollHeight;
}


/**
 * 阿拉伯数字转简体中文大写
 * @param {[type]} Num [description]
 */
export function arabia2SimplifiedChinese(Num) {
  for (var i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(",", "")//替换Num中的“,”
    Num = Num.replace(" ", "")//替换Num中的空格
  }
  if (isNaN(Num)) { //验证输入的字符是否为数字
    //alert("请检查小写金额是否正确");
    return;
  }
  //字符处理完毕后开始转换，采用前后两部分分别转换
  var part = String(Num).split(".");
  var newchar = "";
  //小数点前进行转化
  for (var i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      //alert("位数过大，无法计算");
      return "";
    }//若数量超过拾亿单位，提示
    var tmpnewchar = ""
    var perchar = part[0].charAt(i);
    switch (perchar) {
      case "0": tmpnewchar = "零" + tmpnewchar; break;
      case "1": tmpnewchar = "一" + tmpnewchar; break;
      case "2": tmpnewchar = "二" + tmpnewchar; break;
      case "3": tmpnewchar = "三" + tmpnewchar; break;
      case "4": tmpnewchar = "四" + tmpnewchar; break;
      case "5": tmpnewchar = "五" + tmpnewchar; break;
      case "6": tmpnewchar = "六" + tmpnewchar; break;
      case "7": tmpnewchar = "七" + tmpnewchar; break;
      case "8": tmpnewchar = "八" + tmpnewchar; break;
      case "9": tmpnewchar = "九" + tmpnewchar; break;
    }
    switch (part[0].length - i - 1) {
      case 0: tmpnewchar = tmpnewchar; break;
      case 1: if (perchar != 0) tmpnewchar = tmpnewchar + "十"; break;
      case 2: if (perchar != 0) tmpnewchar = tmpnewchar + "百"; break;
      case 3: if (perchar != 0) tmpnewchar = tmpnewchar + "千"; break;
      case 4: tmpnewchar = tmpnewchar + "万"; break;
      case 5: if (perchar != 0) tmpnewchar = tmpnewchar + "十"; break;
      case 6: if (perchar != 0) tmpnewchar = tmpnewchar + "百"; break;
      case 7: if (perchar != 0) tmpnewchar = tmpnewchar + "千"; break;
      case 8: tmpnewchar = tmpnewchar + "亿"; break;
      case 9: tmpnewchar = tmpnewchar + "十"; break;
    }
    newchar = tmpnewchar + newchar;
  }
  //替换所有无用汉字，直到没有此类无用的数字为止
  while (newchar.search("零零") != -1 || newchar.search("零亿") != -1 || newchar.search("亿万") != -1 || newchar.search("零万") != -1) {
    newchar = newchar.replace("零亿", "亿");
    newchar = newchar.replace("亿万", "亿");
    newchar = newchar.replace("零万", "万");
    newchar = newchar.replace("零零", "零");
  }
  //替换以“一十”开头的，为“十”
  if (newchar.indexOf("一十") == 0) {
    newchar = newchar.substr(1);
  }
  //替换以“零”结尾的，为“”
  if (newchar.lastIndexOf("零") == newchar.length - 1) {
    newchar = newchar.substr(0, newchar.length - 1);
  }
  return newchar;
}

/**
 * 阿拉伯数字转繁体中文大写
 * @param {[type]} Num [description]
 * 壹亿贰仟叁佰肆拾伍万陆仟柒佰捌拾玖元整
 */
export function arabia2TraditionalChinese(Num) {
  for (var i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(",", "")//替换Num中的“,”
    Num = Num.replace(" ", "")//替换Num中的空格
  }
  if (isNaN(Num)) { //验证输入的字符是否为数字
    //alert("请检查小写金额是否正确");
    return;
  }
  //字符处理完毕后开始转换，采用前后两部分分别转换
  var part = String(Num).split(".");
  var newchar = "";
  //小数点前进行转化
  for (var i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      //alert("位数过大，无法计算");
      return "";
    }//若数量超过拾亿单位，提示
    var tmpnewchar = ""
    var perchar = part[0].charAt(i);
    switch (perchar) {
      case "0": tmpnewchar = "零" + tmpnewchar; break;
      case "1": tmpnewchar = "壹" + tmpnewchar; break;
      case "2": tmpnewchar = "贰" + tmpnewchar; break;
      case "3": tmpnewchar = "叁" + tmpnewchar; break;
      case "4": tmpnewchar = "肆" + tmpnewchar; break;
      case "5": tmpnewchar = "伍" + tmpnewchar; break;
      case "6": tmpnewchar = "陆" + tmpnewchar; break;
      case "7": tmpnewchar = "柒" + tmpnewchar; break;
      case "8": tmpnewchar = "捌" + tmpnewchar; break;
      case "9": tmpnewchar = "玖" + tmpnewchar; break;
    }
    switch (part[0].length - i - 1) {
      case 0: tmpnewchar = tmpnewchar; break;
      case 1: if (perchar != 0) tmpnewchar = tmpnewchar + "拾"; break;
      case 2: if (perchar != 0) tmpnewchar = tmpnewchar + "佰"; break;
      case 3: if (perchar != 0) tmpnewchar = tmpnewchar + "仟"; break;
      case 4: tmpnewchar = tmpnewchar + "万"; break;
      case 5: if (perchar != 0) tmpnewchar = tmpnewchar + "拾"; break;
      case 6: if (perchar != 0) tmpnewchar = tmpnewchar + "佰"; break;
      case 7: if (perchar != 0) tmpnewchar = tmpnewchar + "仟"; break;
      case 8: tmpnewchar = tmpnewchar + "亿"; break;
      case 9: tmpnewchar = tmpnewchar + "拾"; break;
    }
    newchar = tmpnewchar + newchar;
  }
  //替换所有无用汉字，直到没有此类无用的数字为止
  while (newchar.search("零零") != -1 || newchar.search("零亿") != -1 || newchar.search("亿万") != -1 || newchar.search("零万") != -1) {
    newchar = newchar.replace("零亿", "亿");
    newchar = newchar.replace("亿万", "亿");
    newchar = newchar.replace("零万", "万");
    newchar = newchar.replace("零零", "零");
  }
  //替换以“一十”开头的，为“十”
  if (newchar.indexOf("壹拾") == 0) {
    newchar = newchar.substr(1);
  }
  //替换以“零”结尾的，为“”
  if (newchar.lastIndexOf("零") == newchar.length - 1) {
    newchar = newchar.substr(0, newchar.length - 1);
  }
  return newchar;
}


/**
 * HTML5 消息
 * @author ammo 2018-05-29
 * @param  {[type]} title   [description]
 * @param  {[type]} message [description]
 * @return {[type]}         [description]
 */
export function notifiyDesk(title, message) {
    var title = title || '新的消息'
    var options = options || {
      body: message || '默认消息',
      icon: $.getCookie('vers') == 'hy' ? prizehy : prize
    }
    // 首先检查浏览器是否支持
    if (!('Notification' in window)) {
        return;
    }
    //如果没有拒绝Notification，就申请用户允许
    if (Notification.permission === 'denied') {
      return;
    }
    //回调模式
    Notification.requestPermission(function (permission) {
      if (permission === 'granted') {
        var notifycation = new Notification(title, options)
        notifycation.onclick=function(){
          window.focus()
          notifycation.close();
        }
        return;
      }
    })
}

/**
 * 生成日期
 * @author ammo 2018-06-07
 * @param  {[type]} dateBaseNow [基于今天的日期，例如要生成昨天，那么传入-1，今天0，明天1，后天2]
 * @param  {[type]} format      [格式]
 * @return {[type]}             [description]
 */
export function makeDateBaseNow(dateBaseNow=0, format='YYYY-MM-DD'){
  let date = new Date()
  date.setDate(date.getDate() + dateBaseNow)
  return new Date(date).pattern(format);
}

/**
 * 获取INPUT Radio 值
 * @author ammo 2018-06-08
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
export function getRadioValue(name){
  return _.find(document.getElementsByName(name), (item) => item.checked).value
}

/**
 * 获取DOM值
 * @author ammo 2018-06-08
 * @param  {[type]} id [description]
 * @return {[type]}    [description]
 */
export function getEleValueById(id){
  if (document.getElementById(id)) {
    return document.getElementById(id).value
  }
  return ''
}

/**
 * 设置DOM值
 * @author ammo 2018-06-08
 * @param  {[type]} id    [description]
 * @param  {[type]} value [description]
 */
export function setEleValueById(id, value){
  if (!document.getElementById(id)) {
    return;
  }
  document.getElementById(id).value = value
}


/**
 * 返回钱格式
 * @author ammo 2018-06-12
 * @param  {[type]} money [description]
 * @return {[type]}       [description]
 */
export function moneyFormat(money, places=2){
  return Number(money).toFixed(places).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}


/**
 * 返回页面顶部
 * @author circle 2018-06-12
 * @param  {[type]} speed   [滚动速度]
 * @param  {[type]} time    [滚动时间]
 */
export function goToTop(speed, time) {
  speed = speed || 0.3;
  time = time || 15;
  var x1 = 0, y1 = 0, x2 = 0, y2 = 0, x3 = 0, y3 = 0;
  if (document.documentElement) {
    x1 = document.documentElement.scrollLeft || 0;
    y1 = document.documentElement.scrollTop || 0;
  }
  if (document.body) {
    x2 = document.body.scrollLeft || 0;
    y2 = document.body.scrollTop || 0;
  }
  x3 = window.scrollX || 0;
  y3 = window.scrollY || 0;
  
  var x = Math.max(x1, Math.max(x2, x3));
  var y = Math.max(y1, Math.max(y2, y3));
  var seed = 1 + speed;//加速度
  window.scrollTo(Math.floor(x / seed), Math.floor(y / seed));
  
  if (x > 0 || y > 0) {
    window.setTimeout(function () {
      this.goToTop(speed, time);
    }.bind(this), time);
  }
}

/**
 * 日期格式化库
 * @author ammo 2018-06-25
 * @return {[type]} [description]
 */
export function momentDate(date){
  return moment(date);
}

export function disableScroll(){
	document.documentElement.style.overflowY = "hidden";
}

export function enableScroll() {
	document.documentElement.style.overflowY = "auto";
}

export function makeLott(lotteryMenu){
  if(!window.webSettings || !window.webSettings.lottery_enabled){
    return lotteryMenu
  }
  let newMenus = [];
  _.each(lotteryMenu, (item) => {
    newMenus.push({...item, lotterys: _.filter(item.lotterys, (it) => _.includes(window.webSettings.lottery_enabled, `${it.lotteryId}`))})
  })
  return newMenus
}

export function moneyDX(num) {
  var strOutput = "";
  var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
  num += "00";
  var intPos = num.indexOf('.');
  if (intPos >= 0)
      num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
  strUnit = strUnit.substr(strUnit.length - num.length);
  for (var i=0; i < num.length; i++)
      strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i,1),1) + strUnit.substr(i,1);
  return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
}
